import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import api from "../../../api/Api";
import "./AssignSummary.css"

function AllAssign() {
  const [assign, setAssign] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setpageSize] = useState(8);
  const [sortField, setSortField] = useState("name");
  const [sortOrder, setSortOrder] = useState("desc");


  const fetchAssign = (page) => {
    api
      .post("/api/assignments/summary", {
        search: search && search.trim() !== "" ? search : null
      }, {
        params: {
          page,
          size: pageSize,
          sort: `${sortField},${sortOrder}`,
        },
      })
      .then((res) => {
        setAssign(res.data.response.content);
        setTotalPages(res.data.response.totalPages);

      })
      .catch((error) => {
        console.error("Error fetching assignment summary:", error);
      });
  };

  useEffect(() => {
    fetchAssign(page);
  }, [page, sortField, sortOrder, search]);

  const handlePageChange = (event, value) => {
    setPage(value - 1);
    // fetchAssign(value - 1);
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setPage(0);
      // fetchAssign(0);
    }, 100);
    return () => clearTimeout(delayDebounce);
  }, [search]);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };



  return (
    <div className="container-fluid"
      style={{
        backgroundColor: "#f9f9f9",
        height: "100%",
        borderRadius: '20px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Fixed Header */}
      <div className="d-flex justify-content-between align-items-center pt-3 flex-wrap">
        <h2 className="mb-2">All Assignments</h2>
        <input
          className="form-control rounded-pill p-3 mb-2"
          style={{ width: '60%', fontSize: '15px' }}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by employee name or id..."
        />
        <Link to="/assignments/add" className="btn btn-primary mb-2">
          + Add Assignment
        </Link>
      </div>

      {/* Scrollable Table */}
      <div style={{ flex: 1, padding: '0 1rem',paddingTop:'25px'}}>

        <table className="table table-bordered table-hover shadow-sm">
          <thead className="table-primary">
            <tr>
              <th style={{ position: 'sticky', top: 0, background: '#0D59A7', color: 'white', zIndex: 1, cursor: 'pointer' }}
                onClick={() => handleSort('name')} >
                Employee Name {sortField === 'name' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
              </th>
              <th style={{ position: 'sticky', top: 0, background: '#0D59A7', color: 'white', zIndex: 1, cursor: 'pointer' }}
                onClick={() => handleSort('employeeId')}>
                Employee ID {sortField === 'employeeId' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
              </th>
              <th style={{ position: 'sticky', top: 0, background: '#0D59A7', color: 'white', zIndex: 1, cursor: 'pointer' }}
                onClick={() => handleSort('email')}>
                Email {sortField === 'email' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
              </th>
              <th style={{ position: 'sticky', top: 0, background: '#0D59A7', color: 'white', zIndex: 1, 
              // cursor: 'pointer' 
            }}
                // onClick={() => handleSort('assigned')}
                >
                Total 
                {/* {sortField === 'assigned' ? (sortOrder === 'asc' ? '↑' : '↓') : ''} */}
              </th>
              <th style={{ position: 'sticky', top: 0, background: '#0D59A7', color: 'white', zIndex: 1 }}>
                Action
              </th>

            </tr>
          </thead>
          <tbody>
            {assign.length > 0 ? (
              assign.map((a) => (
                <tr key={a.employeeIdenty}>
                  <td className="text-capitalize">{a.employeeName}</td>
                  <td>{a.employeeId}</td>
                  <td>{a.email}</td>
                  <td>{a.assigned}</td>
                  <td>
                    <div className='text-center'>
                      <Link
                        to={`/assignments/name/${a.employeeIdenty}`}
                        className="custom-btn rounded-pill">
                        View
                      </Link>
                    </div>

                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center text-muted">No assignments found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* MUI Pagination */}
      <div className="d-flex justify-content-center mb-1">
        <Stack spacing={2}>
          <Pagination
            count={totalPages}
            page={page + 1}
            onChange={handlePageChange}
            color="primary"
            shape="rounded"
            variant="outlined"
          />
        </Stack>
      </div>
    </div>
  );

}

export default AllAssign;
